import { fetchAuthSession } from 'aws-amplify/auth';
import axiosBase from 'axios';

import { getMessage } from '@/common/messages';
/**
 * http通信を行うクラス
 */
import constants from '@/config/constants';
import { i18n } from '@/plugin/i18n';
import router from '@/router';
import store from '@/store/index.js';

const http = axiosBase.create({
  baseURL: constants.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF8',
    'x-api-key': constants.API_KEY,
    'Accept-Language': i18n.global.locale
  },
  responseType: 'json',
  timeout: constants.API_TIMEOUT
});

http.interceptors.request.use(async config => {
  // allowNonLoginAccessは最優先で通す
  if (config.data && config.data.allowNonLoginAccess) {
    return config;
  }

  let token = '';
  let isAuthenticated = false;

  // 認証状態とトークンを取得
  try {
    const session = await fetchAuthSession();
    if (session.tokens?.idToken) {
      // v6ではtoString()を使用してJWTトークン文字列を取得
      token = session.tokens.idToken.toString();
      isAuthenticated = true;
    }
  } catch (error) {
    // fetchAuthSession失敗時は未認証扱い
    isAuthenticated = false;
  }

  // 認証済みの場合: Authorizationヘッダーを設定してリクエスト送信
  if (isAuthenticated && token) {
    config.headers.Authorization = token;
    return config;
  }

  // 未認証でNoLoginAccessが設定されている場合: nologinuseridを設定してリクエスト送信
  if (config.NoLoginAccess || config.data?.NoLoginAccess) {
    let userId = store.getters['user/user_id'];
    if (userId) {
      config.headers.nologinuserid = userId;
    }
    return config;
  }

  // 未認証でNoLoginAccessもない場合: ログイン画面へリダイレクトしてリクエスト中断
  console.error('[/src/common/http][interceptors.request]', 'User not authenticated');
  alert('ログインされていません。');
  router.push('/login');
  return Promise.reject(new Error('User not authenticated'));
});

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status == 400) {
        // ビジネスチェックエラー
        throw error.response.data;
      } else if (error.response.status >= 500) {
        // サーバエラー
        // リトライ確認
        if (confirm(getMessage('CONFIRM_SERVER_ERROR_RETRY'))) {
          // リトライ
          if (typeof error.config.data === 'string') {
            error.config.data = JSON.parse(error.config.data);
          }
          return http.request(error.config);
        }
        throw error;
      }
    }
    throw error;
  }
);

export default http;
